module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content has-text-centered"
  }, [_c('p', [_c('img', {
    attrs: {
      "width": "200",
      "src": require("assets/logo.svg"),
      "alt": _vm.description
    }
  })]), _vm._v(" "), _c('h1', {
    staticClass: "is-title is-bold"
  }, [_vm._v(_vm._s(_vm.name.replace('-', ' ')))]), _vm._v(" "), _c('p', [_c('strong', [_vm._v(_vm._s(_vm.description))])]), _vm._v(" "), _c('p', [_vm._v("Help small business manage their businesses and also learn from data generated by business")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fcc8eae0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/views/Home.vue
// module id = 234
// module chunks = 17